import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as PaymentCard } from 'assets/images/payment-card.svg';
import Button from 'components/Buttons/Button';

export const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    bottom: 0;
    left: 0;
    box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
    background: ${({ theme }) => theme.group.whiteGrey};
  }

  @media ${({ theme }) => theme.device.desktop} {
    padding: 18px 0;
    margin-top: -24px;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: 5px;
  box-shadow: 0 4px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  background: ${ColorPalette.HEX.White};
  color: ${ColorPalette.HEX.DimGray};
  padding: 16px;
  height: auto;

  & img {
    vertical-align: middle;
    margin-right: 9px;
  }
`;
export const AddCardIcon = styled(PaymentCard)`
  width: 24px;
  height: 24px;
  color: ${ColorPalette.HEX.OriolesOrange};
  vertical-align: middle;
  margin-right: 9px;
`;
